import { Link } from "react-router-dom";
import LegalShell, { Section } from "../components/LegalShell";

const TermsPage: React.FC = () => (
  <LegalShell title="Terms & Conditions" updated="June 16, 2026">
    <p>
      These Terms &amp; Conditions ("Terms") govern your use of Kinoes ("Kinoes", "we",
      "us"), a service that helps a family decide what to do on a given evening. By using
      the service, you agree to these Terms.
    </p>

    <Section heading="The service">
      <p>
        Kinoes lets an organizer invite family members by text, gathers each person's
        preferences through an AI assistant, narrows to a few options, runs a vote, and
        shares the group's decision. Suggestions are generated with the help of artificial
        intelligence and third-party data and are provided for convenience only.
      </p>
    </Section>

    <Section heading="Eligibility and accounts">
      <p>
        You must be at least 18 years old to act as an organizer. The organizer is
        responsible for their family group, including adding members and confirming they
        have permission to include each member's mobile number.
      </p>
    </Section>

    <Section heading="Acceptable use">
      <ul className="list-disc pl-6 space-y-1">
        <li>Only add a mobile number if you have that person's permission to text them via Kinoes.</li>
        <li>Do not use the service for unlawful, harmful, or abusive purposes.</li>
        <li>Do not attempt to disrupt or gain unauthorized access to the service.</li>
      </ul>
    </Section>

    <Section heading="SMS messaging">
      <p>
        Use of SMS is subject to our{" "}
        <Link to="/sms-policy" className="text-primary-600">SMS Terms &amp; Opt-In Policy</Link>.
        Message and data rates may apply. Reply STOP to opt out or HELP for help.
      </p>
    </Section>

    <Section heading="AI suggestions and third-party venues">
      <p>
        Options are suggestions only. We do not guarantee that any venue, event, price,
        hours, or availability is accurate or current, and we are not responsible for
        third-party businesses or events. Always verify details and use your own judgment,
        including for safety and suitability.
      </p>
    </Section>

    <Section heading="Disclaimer of warranties">
      <p>
        The service is provided "as is" and "as available" without warranties of any kind,
        whether express or implied, to the fullest extent permitted by law.
      </p>
    </Section>

    <Section heading="Limitation of liability">
      <p>
        To the fullest extent permitted by law, Kinoes will not be liable for any indirect,
        incidental, special, consequential, or punitive damages, or any loss arising out of
        your use of, or inability to use, the service.
      </p>
    </Section>

    <Section heading="Changes">
      <p>
        We may update these Terms from time to time. Continued use of the service after a
        change means you accept the updated Terms.
      </p>
    </Section>

    <Section heading="Governing law">
      <p>
        These Terms are governed by the laws of the State of Washington, USA, without
        regard to its conflict-of-laws rules.
      </p>
    </Section>

    <Section heading="Contact us">
      <p>
        Questions about these Terms? Email{" "}
        <a className="text-primary-600" href="mailto:support@kinoes.com">support@kinoes.com</a>.
      </p>
    </Section>
  </LegalShell>
);

export default TermsPage;
